import React from "react";
import BookingForm from "./BookingForm";
import { useLang } from "@/i18n/LanguageContext";

const BookingSection = () => {
  const { t } = useLang();
  return (
    <section
      id="booking"
      data-testid="booking-section"
      className="py-24 sm:py-32 bg-[#F9F6F0]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="mb-12 max-w-2xl">
          <p className="text-[#2E4F4F] text-xs uppercase tracking-[0.3em] mb-4">
            {t.booking.eyebrow}
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl text-[#1A1F24] tracking-tight">
            {t.booking.title}
          </h2>
        </div>
        <BookingForm />
      </div>
    </section>
  );
};

export default BookingSection;
